import React, { useEffect, useState } from "react";
import "./SetPassword.scss";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import axios from "../../../utils/axios";

import { useNavigate } from "react-router";
import BaseDialog from "../../../modelDialogs/BaseDialog";
import LanguagePicker from "../../../LanguagePicker";
import { encrypt } from "../Login/Login";

export default function SetPassword() {
  const [seePassword, setSeePassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    state._navigate = navigate;
  }, []);

  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const token = queryParameters.get("token");

  const resetPasswordSchema = Yup.object().shape({
    password: Yup.string().required(state.translate("register.passwordEnter", "Please enter Password!")).min(8),
    confirmpassword: Yup.string()
      .required(state.translate("register.passwordEnter", "Please enter Password!"))
      .oneOf(
        [
          Yup.ref(
            "password", // no itx
          ),
          null,
        ],
        state.translate("setPassword.passwordMustMatch", "Passwords must match"),
      ),
  });
  const resetPassword = (values: any, { setSubmitting }: any) => {
    if (token && id) {
      const payload = {
        userId: id,
        token: token,
        password: encrypt(values.password),
      };
      axios
        .post(`/api/forget/set-password`, payload)
        .then((result: any) => {
          state.dialogManager.openDialog(
            <BaseDialog
              title={state.translate("Success", "Success")}
              onOk={() => {
                state.navigate("/login");
                return true;
              }}
              okCaption={state.translate("ok", "Ok")}
              noAbortButton={true}
            >
              <div style={{ padding: "20px" }}>
                {state.translate(
                  "setPassword.passwordSucessfullyChanged",
                  "Your have successfully changed your password.",
                )}
              </div>
            </BaseDialog>,
          );
        })
        .catch((e) => {
          if (e.STATUS === "FAILURE") {
            state.dialogManager.openDialog(
              <BaseDialog
                title={state.translate("error", "Error")}
                onOk={() => {
                  state.navigate("/login");
                  return true;
                }}
                okCaption={state.translate("ok", "Ok")}
                noAbortButton={true}
              >
                <div style={{ padding: "20px" }}>
                  {state.translate("setPassword.tokenExpired", "Token Expired. Please Try Again.")}
                </div>
              </BaseDialog>,
            );
          }
        })
        .finally(() => setSubmitting(false));
    } else {
      state.dialogManager.openDialog(
        <BaseDialog
          title={state.translate("error", "Error")}
          onOk={() => {
            state.navigate("/login");
            return true;
          }}
          okCaption={state.translate("ok", "Ok")}
          noAbortButton={true}
        >
          <div style={{ padding: "20px" }}>
            {state.translate("setPassword.somthingWentwrong", "Something Went Wrong. Please Try Again.")}
          </div>
        </BaseDialog>,
      );
    }
  };

  return (
    <div className="SetPassword main-form">
      <div className="lView">
        <div className="head">
          <span className="title form-title">{state.translate("forgotPassword.resetPassword", "Reset Password")}</span>
        </div>
        <div className="seperator invisible">
          <div />
          <div />
        </div>
        <Formik
          initialValues={{ email: "", password: "" }}
          onSubmit={resetPassword}
          validationSchema={resetPasswordSchema}
        >
          {({ isSubmitting }) => {
            return (
              <Form>
                <div className="inp" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  <label className="field-container">
                    <span className="form-label">
                      {/* {state.translate("loginPage.password", "Password")} <RequiredLabel /> */}
                    </span>
                    <span className="form-span input-container" style={{ position: "relative" }}>
                      <i className="la la-lock la-lg input-icon" />
                      <Field
                        className="form-input input-field form-input-override"
                        style={{
                          fontSize: "16px !important",
                          height: "39px",
                          color: "black !important",
                          borderRadius: "3px",
                          background: "#f0f0f0 !important",
                        }}
                        type={!seePassword ? "password" : "text"} // no itx
                        name="password" // no itx
                        placeholder=""
                      />
                      <label className="input-label">
                        {state.translate("loginPage.password", "Password")}
                        {/* <RequiredLabel /> */}
                      </label>
                      <i
                        className="las la-eye"
                        style={{
                          color: "black",
                          position: "absolute",
                          right: "10px",
                        }}
                        onMouseDown={() => setSeePassword(true)}
                        onMouseUp={() => setSeePassword(false)}
                      />
                    </span>
                    <ErrorMessage className="form-error" name="password" component="div" />
                  </label>
                  <label className="field-container">
                    <span className="form-label">
                      {/* {state.translate("setPassword.confirmPassword", "Confirm Password")} <RequiredLabel /> */}
                    </span>
                    <span className="form-span input-container">
                      <i className="la la-lock la-lg input-icon" />
                      <Field
                        className="form-input input-field form-input-override"
                        type="password" // no itx
                        name="confirmpassword" // no itx
                        placeholder=""
                      />
                      <label className="input-label">
                        {state.translate("setPassword.confirmPassword", "Confirm Password")}
                        {/* <RequiredLabel /> */}
                      </label>
                    </span>
                    <ErrorMessage className="form-error" name="confirmpassword" component="div" />
                  </label>
                </div>
                <div className="endItems">
                  <button
                    disabled={isSubmitting}
                    className="submit confirm-button confirm-button-override"
                    type="submit" // no itx
                  >
                    <span>{state.translate("forgotPassword.resetPassword", "Reset Password")}</span>
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <div className="rView">
        <img
          src="/images/auth/rView.png" // no itx
          alt=""
        />
      </div>
      <LanguagePicker className="language-picker" />
    </div>
  );
}
